import React from 'react';
import Loading from './Loading';
import PropTypes from 'prop-types';

function RelativeLoading({ className }) {
  return (
    <span
      className={`w-100 position-relative d-flex justify-content-center align-items-center ${className}`}
    >
      <Loading inline />
    </span>
  );
}

export default RelativeLoading;

RelativeLoading.propTypes = {
  className: PropTypes.any,
};
